import Modal from './Modal';
import ModalActions from './ModalActions';
import ModalBody from './ModalBody';
import ModalClose from './ModalClose';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import ModalTitle from './ModalTitle';

export { Modal, ModalActions, ModalBody, ModalClose, ModalFooter, ModalHeader, ModalTitle };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-modal/es/index.js
// module id = 171
// module chunks = 0